import { Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import React from 'react'
import { PermissionWrapper } from '../../../wrappers';

const referanceDocumentsHD = ({ onRequestSort, sortConfig, item, toggleBulkOps, bulk }) => {
    const handelSorting = (property) => (event) => {
        onRequestSort(event, property);
    }

  return (
    <TableHead>
    <TableRow>
        <TableCell className="table-actions-header" sx={{whiteSpace: "nowrap", width: "140px"}}>
            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reference_document", operationType: ['D'] }}>
            <Checkbox size='small' sx={{ cursor: 'pointer' }} onChange={(e) => toggleBulkOps(e.target.checked, "bulk", item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} /></PermissionWrapper> Action(s)
        </TableCell>
        <TableCell sx={{minWidth: "100px", whiteSpace: "nowrap"}} >
            <TableSortLabel active={sortConfig?.field === "name"} direction={sortConfig?.field === "name" ? sortConfig.direction : "asc"} onClick={handelSorting("name")}> Name</TableSortLabel>
        </TableCell>
        <TableCell sx={{minWidth: "100px", whiteSpace: "nowrap"}} >
            <TableSortLabel onClick={handelSorting("validity_start_date")} active={sortConfig?.field === "validity_start_date"} direction={sortConfig?.field === "validity_start_date" ? sortConfig.direction : "asc"}>Validity Start Date</TableSortLabel>  
        </TableCell>
        <TableCell sx={{minWidth: "100px", whiteSpace: "nowrap"}} >
            <TableSortLabel onClick={handelSorting("validity_end_date")} active={sortConfig?.field === "validity_end_date"} direction={sortConfig?.field === "validity_end_date" ? sortConfig.direction : "asc"}>Validity End Date</TableSortLabel>
        </TableCell>
        <TableCell> 
            <TableSortLabel sx={{minWidth: "150px", whiteSpace: "nowrap"}} onClick={handelSorting("description")} active={sortConfig?.field === "description"} direction={sortConfig?.field === "description" ? sortConfig.direction : "asc"} >Description</TableSortLabel>
        </TableCell>
    </TableRow>
    </TableHead>
  )
}

export default referanceDocumentsHD;